import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import DragDropComponente from '../../../componentes/dragdrog/dragdrop.componente';
import HistologiaFiltro from '../common/histologia-filtro.container';
import CancelarContainer from '../common/modais/cancelar/cancelar.container';
import NConformidadeContainer from '../common/modais/nconformidade/nconformidade.container';
import ButtonFloating from '../../../componentes/button/button-floating.component';
import BlocoLote from '../common/bloco.lote';

import '../common/histologia.styles.css';
import { useIntl } from 'react-intl';

const InclusaoPage = (props) => {
	const intl = useIntl()
	return (
		<div>
			{props.modalOpenCancelar && (
				<CancelarContainer
					open={props.modalOpenCancelar}
					toggle={props.toggleModalCancelar}
					item={props.itemInModal}
				></CancelarContainer>
			)}
			{props.modalOpenNaoConfor && (
				<NConformidadeContainer
					intl={intl}
					open={props.modalOpenNaoConfor}
					toggle={props.toggleModalNaoConfor}
					item={props.itemInModal}
					naoconformidades={props.naoconformidades}
					usuarioLocal={props.usuarioLocal}
				></NConformidadeContainer>
			)}
			{props.showModalImprimirBlocosEmLote && (
				<BlocoLote
					showModal={props.showModalImprimirBlocosEmLote}
					toggleModal={props.toggleModalImprimirBlocosEmLote}
					imprimirEtiquetas={props.imprimirEtiquetaEmLote}
					blocosParaEtiqueta={props.blocosParaEtiqueta}
				/>
			)}

			<Container fluid className='mv-histologia-container'>
				<Row>
					<Col>
						<HistologiaFiltro
							limparFiltro={props.limparFiltro}
							intl={intl}
							carregando={props.carregando}
							tecnicos={props.tecnicos}
							tecnicoSelecionado={props.tecnicoSelecionado}
							periodoInicial={props.periodoInicial}
							periodoFinal={props.periodoFinal}
							onChangeData={props.onChangeData}
							onChangeTecnico={props.onChangeTecnico}
							onChangeNumeroExame={props.onChangeNumeroExame}
							onKeyPressNumeroExame={props.onKeyPressNumeroExame}
							numeroDoExame={props.numeroDoExame}
							onClickSearch={props.buscar}
							onClickOrganize={props.organizar}
							onClickOrdem={props.onClickOrdem}
							sortAsc={props.sortAsc}
							periodos={props.periodos}
							periodo={props.periodo}
							onChangePeriodo={props.onChangePeriodo}
							mudarIntervaloPeriodo={props.mudarIntervaloPeriodo}
							onKeyPressData={props.onKeyPressData}
							onChangeNumeroPedido={props.onChangeNumeroPedido}
							onKeyPressNumeroPedido={props.onKeyPressNumeroPedido}
							numeroDoPedido={props.numeroDoPedido}
						/>

						<Row style={{ height: props.altura }}>
							<DragDropComponente
								{...props}
								list={props.lista}
								update={props.atualizarListaNoState}
							/>
							<ButtonFloating
								actions={[
									{
										className: 'mv-basico-codigo_barras',
										backgroundColor: '#2196f3',
										color: '#ffffff',
										texto: 'Blocos em lote',
										onClick: props.toggleModalImprimirBlocosEmLote
									}
								]}
							/>
						</Row>
					</Col>
				</Row>
			</Container>
		</div>
	);
};

export default InclusaoPage;



// WEBPACK FOOTER //
// ./src/pages/histologia/inclusao/inclusao.page.js